$(() => {

    $('a.anchor-view-all').each(function(index, element) {
        const anchorName = '#anchor' + $(element).text();
        $(element).attr('href', anchorName);
    });

    $('div.all-series-content-parts__ttl').each(function(index, element) {
        const anchorName = 'anchor' + $(element).text();
        $(element).attr('id', anchorName);
    });

    $('body').on('click', 'a[href^="#"]', function () {
        const adjust = 0;
        const speed = 400;
        const href = $(this).attr('href');
        const target = $(href == '#' || href == '' ? 'html' : href);
        const position = target.offset().top + adjust;
        $('body,html').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });
});
